import React from 'react';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

const CustomLink = ({ Children, to, ...props }) => {
   let resolved = useResolvedPath(to);
   let match = useMatch({ path: resolved.pathname, end: true });

   return (
      <div>
        <Link to={to} {...props} className={`${match ? 'underline underline-offset-8 font-semibold text-pink-400' : ' font-semibold'}`} >
        </Link>
      </div>
)
}

export default CustomLink;